import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import {
  BRAND_SEARCH_CAROUSEL_CONTAINER_NAME,
  BrandSearch,
} from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/SearchPageBrandSearch/BrandSearch/BrandSearch";
import { useSearchPageShouldShowBrandSearch } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/useSearchPageShouldShowBrandSearch";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useSearchPageQuery } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/__internal__/useSearchPageQuery";
import { useSearchPageBrandRelatedProductTiles } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageBrandRelatedProductTiles";
import { useSearchPageInsiderMembershipMessage } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageInsiderMembershipMessage";
import { useSearchPageQueryIsLoading } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageQueryIsLoading";
import { useSearchPageRequestId } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageRequestId";
import { useSearchPageSuggestedBrandInfo } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageSuggestedBrandInfo";
import { useSearchPageProductSearchString } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";
import { HorizontalLine } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import React from "react";
import styled from "styled-components";

export const SearchPageBrandSearch = () => {
  const shouldShowBrandSearch = useSearchPageShouldShowBrandSearch();
  const loading = useSearchPageQueryIsLoading();
  const searchString = useSearchPageProductSearchString();
  const requestId = useSearchPageRequestId();
  const searchPageSuggestedBrandCtaText =
    useSearchPageQuery().data?.suggested_brand_cta_text;
  const brandRelatedProductTiles = useSearchPageBrandRelatedProductTiles();
  const suggestedBrandInfo = useSearchPageSuggestedBrandInfo();
  const insiderMessage = useSearchPageInsiderMembershipMessage();
  const isLoggedInRetailer = useIsLoggedInRetailer();
  return shouldShowBrandSearch && !loading ? (
    <>
      {isLoggedInRetailer ? <Spacer height="5x" /> : <Spacer height="2x" />}
      <StyledBrandSearch
        isOnSearchPage
        products={brandRelatedProductTiles}
        brand={suggestedBrandInfo}
        containerName={BRAND_SEARCH_CAROUSEL_CONTAINER_NAME}
        isLoading={loading}
        queryString={searchString}
        ctaText={searchPageSuggestedBrandCtaText}
        requestId={requestId}
        insiderMessage={insiderMessage}
        mobilePadding={isLoggedInRetailer ? 8 : 16}
        $useTightenedSpacing={isLoggedInRetailer}
      />
      <ResponsiveContentV2
        tabletAndAbove={
          <>
            <Spacer height="4x" />
            {!isLoggedInRetailer ? null : <HorizontalLine />}
          </>
        }
      />
    </>
  ) : null;
};

const StyledBrandSearch = styled(BrandSearch)<{
  $useTightenedSpacing: boolean;
}>`
  padding: 0;

  ${responsiveMediaQueries.mobile} {
    margin-left: ${({ $useTightenedSpacing }) =>
      $useTightenedSpacing ? "-2px" : getSpacing("-2x")};
  }
`;
